
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/license",
      function () {
        return require("private-next-pages/license.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/license"])
      });
    }
  